import React, {memo} from 'react';
import {EnvelopeMessageProps} from '../types/EnvelopeTypes';

export const EnvelopeMessage: React.FC<EnvelopeMessageProps> = memo(({message, textColor}) => {
  if (!message) return null;

  return (
    <div className="envelope_image__wrapper__text">
      <span style={{color: textColor}}>{message}</span>
    </div>
  );
});
